import PropTypes from 'prop-types';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export const TransactionTable = ({ transactions, businessData }) => {
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);

  const handleDownload = transaction => {
    navigate('/dashboard/receipt', { state: { transaction } });
  };

  const handleSelectTransaction = transactionId => {
    setSelectedIds(prevIds =>
      prevIds.includes(transactionId)
        ? prevIds.filter(id => id !== transactionId)
        : [...prevIds, transactionId]
    );
  };

  console.log(transactions);

  const handleSelectAll = () => {
    if (selectedIds.length === transactions.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(transactions.map(t => t.id));
    }
  };

  const handlePrintSelected = () => {
    if (selectedIds.length === 0) {
      toast('Please select at least one transaction to print');
      return;
    }
    const selectedTransactions = transactions.filter(t => selectedIds.includes(t.id));
    navigate('/dashboard/receipt', {
      state: { transactions: selectedTransactions, businessData: businessData },
    });
  };

  return (
    <div className="px-4 overflow-x-auto">
      <div className="flex items-center justify-between mb-4">
        <div className="p-2 font-light text-sm text-[#000000]">
          {selectedIds.length} transaction(s) selected
        </div>
        <button
          onClick={handlePrintSelected}
          disabled={selectedIds.length === 0}
          className={`px-4 py-1 mr-[76px] mt-3 border border-[#000000] rounded-lg font-light text-sm ${
            selectedIds.length === 0
              ? 'bg-white text-[#000000] cursor-not-allowed'
              : 'bg-[#000000] text-white'
          }`}>
          Print Selected
        </button>
      </div>
      <table className="w-full mt-4 border-collapse">
        <thead>
          <tr className="text-left">
            <th className="flex items-center gap-2 p-2">
              <input
                type="checkbox"
                checked={selectedIds.length === transactions.length && transactions.length > 0}
                onChange={handleSelectAll}
                className="w-3 h-3"
              />
              <label htmlFor="select" className="p-2 font-light text-sm text-[#718EBF]">
                Plan Name
              </label>
            </th>
            <th className="p-2 font-light text-sm text-[#718EBF]">Subscription ID</th>
            <th className="p-2 font-light text-sm text-[#718EBF]">Start Date</th>
            <th className="p-2 font-light text-sm text-[#718EBF]">Status</th>
            <th className="p-2 font-light text-sm text-[#718EBF]">Amount</th>
            <th className="p-2 font-light text-sm text-[#718EBF]">Receipt</th>
          </tr>
        </thead>
        <tbody>
          {transactions?.length > 0 ? (
            transactions.map((transaction, index) => (
              <tr key={transaction.id} className="hover:bg-gray-100">
                <td className="flex items-center gap-4 p-2">
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(transaction?.id)}
                    onChange={() => handleSelectTransaction(transaction?.id)}
                  />
                  <span className="font-light text-sm text-[#232323]">
                    {transaction?.description || '-'}
                  </span>
                </td>
                <td className="p-2 font-light text-sm text-[#232323]">{transaction?.id || '-'}</td>
                <td className="p-2 font-light text-sm text-[#232323]">
                  {transaction?.date || '-'}
                </td>
                <td className="p-2 font-light text-sm text-[#232323]">
                  {transaction?.status || '-'}
                </td>
                <td className="p-2 font-light text-sm text-[#232323]">
                  {transaction?.amount || '-'}
                </td>
                <td className="p-2">
                  <button
                    onClick={() => handleDownload(transaction)}
                    className="px-4 py-1 border border-[#000000] rounded-lg font-light text-sm text-[#000000]">
                    Download
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="h-40 text-center text-gray-500">
                No table data available for the selected period
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

TransactionTable.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string,
      date: PropTypes.string,
      status: PropTypes.string,
      amount: PropTypes.string,
    })
  ).isRequired,
};
